<template>
  <div>
    <!-- Empty state -->
    <div v-if="!count" class="flex flex-col items-center">
      <star-rating :count="0" :average="0" :showCount="false" class="!py-0" />
      <!-- Sitter view -->
      <note-box
        v-if="showSitterView"
        class="!mt-16"
        header="Request reviews"
        body="Request a review from any parent you've worked with to add it to your profile"
      />
      <!-- Default view -->
      <p v-else class="text-body mt-8">Be the first to leave a review</p>
    </div>

    <!-- Star Rating + Distribution -->
    <div v-else-if="validAverage" class="flex items-center gap-24">
      <div>
        <star-rating :count="count" :average="average" :showCount="false" class="!py-0" />
        <div class="flex items-center gap-8 mt-8">
          <p class="text-h3 text-brand">{{ formattedStarRating }}</p>
          <p class="text-body text-grey-text-subdued whitespace-nowrap">({{ countDisplayText }})</p>
        </div>
      </div>
      <ratings-distribution :distributionData="distributionData" />
    </div>
  </div>
</template>

<script lang="ts">
import pluralize from 'pluralize';
import StarRating from '../star_rating/StarRating.vue';
import NoteBox from '../note_box/NoteBox.vue';
import RatingsDistribution from '../ratings_distribution/RatingsDistribution.vue';

const LIMIT = 5;

interface DistributionData {
  count: number;
  percent: number;
  stars: number;
}

export default {
  name: 'RatingsOverview',
  components: { StarRating, NoteBox, RatingsDistribution },
  props: {
    count: {
      type: Number,
      required: true,
    },
    average: {
      type: Number,
      required: true,
    },
    distributionData: {
      type: Array as () => Array<DistributionData>,
      default: () => [],
    },
    showSitterView: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    validAverage(): boolean {
      return this.average !== null && this.average >= 0 && this.average <= LIMIT;
    },
    formattedStarRating(): string {
      return this.average.toFixed(1);
    },
    countDisplayText(): string {
      return pluralize('rating', this.count, true);
    },
  },
};
</script>
